import React from 'react'
import { useNavigation } from '@react-navigation/native'

import { buildComponent } from 'src/components/factory'
import { useStore } from 'src/hooks/state'
import * as Firestore from 'src/helpers/firestore'

import * as UI from 'native-base'
import { Alert } from './alert'

export const GongAnnouncement = buildComponent<{
  isOpen: boolean
  onClose: () => void
}>()
  .withLocale('components.elements.gong-announcement')
  .withLifecycle(({ props }) => {
    const Store = useStore()
    const navigation = useNavigation()

    const handleConfigure = () => {
      // Mark announcement as shown
      Firestore.upsertDocument(Firestore.getDocumentReference('preferences'), {
        gongAnnouncementShown: true,
      })
      Store.getActions().profile.updatePreferences({
        gongAnnouncementShown: true,
      })

      // Close the popup
      props.onClose()

      // Navigate to gong configuration
      navigation.navigate('/account/gong' as never)
    }

    const handleClose = () => {
      // Mark announcement as shown when user closes it
      Firestore.upsertDocument(Firestore.getDocumentReference('preferences'), {
        gongAnnouncementShown: true,
      })
      Store.getActions().profile.updatePreferences({
        gongAnnouncementShown: true,
      })

      props.onClose()
    }

    return {
      handleConfigure,
      handleClose,
    }
  })
  .withRender(({ props, lifecycle, locale }) => (
    <Alert
      isOpen={props.isOpen}
      onAccept={lifecycle.handleConfigure}
      onClose={lifecycle.handleClose}
      title={locale('title')}
      acceptLabel={locale('configure')}
    >
      <UI.Text textAlign="center">{locale('subtitle')}</UI.Text>
    </Alert>
  ))
